"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstructionMaterials$ = exports.ConstructionMaterials$outboundSchema = exports.ConstructionMaterials$inboundSchema = void 0;
exports.constructionMaterialsToJSON = constructionMaterialsToJSON;
exports.constructionMaterialsFromJSON = constructionMaterialsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const stringmeta_js_1 = require("./stringmeta.js");
/** @internal */
exports.ConstructionMaterials$inboundSchema = z.object({
    floor_type: z.nullable(stringmeta_js_1.StringMeta$inboundSchema),
    roof_type: z.nullable(stringmeta_js_1.StringMeta$inboundSchema),
    wall_type: z.nullable(stringmeta_js_1.StringMeta$inboundSchema),
    window_type: z.nullable(stringmeta_js_1.StringMeta$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "floor_type": "floorType",
        "roof_type": "roofType",
        "wall_type": "wallType",
        "window_type": "windowType",
    });
});
/** @internal */
exports.ConstructionMaterials$outboundSchema = z.object({
    floorType: z.nullable(stringmeta_js_1.StringMeta$outboundSchema),
    roofType: z.nullable(stringmeta_js_1.StringMeta$outboundSchema),
    wallType: z.nullable(stringmeta_js_1.StringMeta$outboundSchema),
    windowType: z.nullable(stringmeta_js_1.StringMeta$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        floorType: "floor_type",
        roofType: "roof_type",
        wallType: "wall_type",
        windowType: "window_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ConstructionMaterials$;
(function (ConstructionMaterials$) {
    /** @deprecated use `ConstructionMaterials$inboundSchema` instead. */
    ConstructionMaterials$.inboundSchema = exports.ConstructionMaterials$inboundSchema;
    /** @deprecated use `ConstructionMaterials$outboundSchema` instead. */
    ConstructionMaterials$.outboundSchema = exports.ConstructionMaterials$outboundSchema;
})(ConstructionMaterials$ || (exports.ConstructionMaterials$ = ConstructionMaterials$ = {}));
function constructionMaterialsToJSON(constructionMaterials) {
    return JSON.stringify(exports.ConstructionMaterials$outboundSchema.parse(constructionMaterials));
}
function constructionMaterialsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ConstructionMaterials$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ConstructionMaterials' from JSON`);
}
//# sourceMappingURL=constructionmaterials.js.map